// extracted by mini-css-extract-plugin
export default {"layout":"World2Task3Screen_layout__LEzDH","tightGrid":"World2Task3Screen_tightGrid__h-Ahs"};